import React from 'react';
import { Col, Grid, Row } from 'react-bootstrap';
import Datatable from 'react-bs-datatable';

// Testing out datatables
const header =
  localStorage.getItem('role') === 'strataAdmin'
    ? [
        {
          title: 'Username',
          prop: 'username',
          sortable: true,
          filterable: true
        },
        {
          title: 'First Name',
          prop: 'firstName',
          sortable: true,
          filterable: true
        },
        {
          title: 'Last Name',
          prop: 'lastName',
          sortable: true,
          filterable: true
        },
        { title: 'Email', prop: 'email', sortable: true, filterable: true },
        {
          title: 'Phone Number',
          prop: 'phoneNumber',
          sortable: true,
          filterable: true
        },
        { title: 'Role', prop: 'role', sortable: true, filterable: true },
        { title: 'Action', prop: 'button', sortable: false }
      ]
    : [
        {
          title: 'Username',
          prop: 'username',
          sortable: true,
          filterable: true
        },
        {
          title: 'First Name',
          prop: 'firstName',
          sortable: true,
          filterable: true
        },
        {
          title: 'Last Name',
          prop: 'lastName',
          sortable: true,
          filterable: true
        },
        { title: 'Email', prop: 'email', sortable: true, filterable: true },
        {
          title: 'Phone Number',
          prop: 'phoneNumber',
          sortable: true,
          filterable: true
        },
        { title: 'Role', prop: 'role', sortable: true, filterable: true }
      ];
const onSortFunction = {
  date(columnValue) {
    // Convert the string date format to UTC timestamp
    // So the table could sort it by number instead of by string
    return new Date(columnValue);
  }
};

const StrataUnitUserTable = (props) => (
  <div>
    <Grid>
      <Row>
        <Col md={12}>
          <h5>Strata Users</h5>
        </Col>
      </Row>
    </Grid>
    <Grid>
      <Row>
        <Col md={12}>
          <Datatable
            tableHeader={header}
            tableBody={props.strataUsers}
            keyName="strataUnitUserTable"
            tableClass="table table-striped table-bordered table-condensed table-hover"
            rowsPerPage={10}
            rowsPerPageOption={[5, 10, 15, 20, 50, 100]}
            initialSort={{ prop: 'date', isAscending: true }}
            onSort={onSortFunction}
          />
        </Col>
      </Row>
    </Grid>
  </div>
);

export default StrataUnitUserTable;
